import React from 'react';

type BadgeVariant = 'active' | 'inactive' | 'warning' | 'danger' | 'info' | 'default';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  active: 'status-active',
  inactive: 'status-inactive',
  warning: 'status-warning',
  danger: 'status-danger',
  info: 'status-info',
  default: 'bg-secondary text-secondary-foreground',
};

export default function Badge({ children, variant = 'default', className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-2xs font-600 ${variantClasses[variant]} ${className}`}
    >
      {children}
    </span>
  );
}